module.exports = __webpack_public_path__ + "img/primary_4x2_z18.072ff447.svg";